import React from 'react'

const SalesCadentierSubcategory: React.FC = () => (
  <svg width="70" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.0769043" width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4461_1560)" />
    <path
      d="M44.5579 20.8052H40.9697C40.1461 18.3346 37.7932 16.5699 35.0285 16.5699C32.2638 16.5699 29.9109 18.3346 29.0285 20.8052H25.4403C23.6756 20.8052 22.2638 22.2169 22.2638 23.9816V47.3934C22.2638 49.1581 23.6756 50.5699 25.4403 50.5699H44.5579C46.3226 50.5699 47.7344 49.1581 47.7344 47.3934V23.9816C47.7932 22.2757 46.3226 20.8052 44.5579 20.8052ZM35.0285 20.8052C36.205 20.8052 37.1461 21.7463 37.1461 22.9228C37.1461 24.0993 36.205 25.0405 35.0285 25.0405C33.852 25.0405 32.9109 24.0993 32.9109 22.9228C32.9109 21.7463 33.852 20.8052 35.0285 20.8052ZM41.0873 34.0405L35.205 41.4522C34.9109 41.8052 34.5579 42.0405 34.0873 42.0405C34.0285 41.9816 33.9697 42.0405 33.9109 42.0405C33.5579 42.0405 33.1461 41.9228 32.852 41.6287L29.1461 38.4522C28.4991 37.864 28.3814 36.864 28.9697 36.2169C29.5579 35.5699 30.5579 35.4522 31.205 36.0405L33.6756 38.1581L38.4991 32.0405C39.0285 31.3346 40.0285 31.2169 40.7344 31.7463C41.4991 32.3346 41.6167 33.3346 41.0873 34.0405Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4461_1560"
        x1="34.5455"
        y1="0.0769046"
        x2="34.5455"
        y2="70.0769"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#07888D" />
        <stop offset="1" stopColor="#006064" />
      </linearGradient>
    </defs>
  </svg>
)

export default SalesCadentierSubcategory
